module.exports = __webpack_public_path__ + "img/components (17).65656401.png";